import 'vanilla-cookieconsent/dist/cookieconsent.css'
import * as CookieConsent from 'vanilla-cookieconsent'
import type { CookieConsentConfig } from 'vanilla-cookieconsent'

export default defineNuxtPlugin(async () => {
  const runTimeConfig = useRuntimeConfig()

  const config: CookieConsentConfig = {
    guiOptions: {
      consentModal: {
        layout: 'cloud',
        position: 'bottom center',
      },
      preferencesModal: {
        layout: 'box',
        position: 'left',
      },
    },

    onFirstConsent: () => {
    },

    onConsent: () => {

      const prefs = CookieConsent.getUserPreferences()
      const isAccepted:any = (category: string) => prefs.acceptedCategories.includes(category)

      if (typeof window.gtag === 'function') {
        window.gtag('consent', 'update', {
          ad_personalization: isAccepted('ads') ? 'granted' : 'denied',
          ad_storage: isAccepted('ads') ? 'granted' : 'denied',
          ad_user_data: isAccepted('ads') ? 'granted' : 'denied',
          analytics_storage: isAccepted('analytics') ? 'granted' : 'denied',
          functionality_storage: isAccepted('functionality') ? 'granted' : 'denied',
          personalization_storage: isAccepted('personalization') ? 'granted' : 'denied',
          security_storage: 'granted',
        })
      }
    },

    onChange: () => {
    },

    categories: {
      necessary: {
        readOnly: true,
        enabled: true,
      },
      analytics: {
        autoClear: {
          cookies: [
            {
              name: /^(_ga|_gid)/,
            },
          ],
        },
      },
      ads: {},
      functionality: {
        enabled: false,
      },
      personalization: {
        enabled: false,
      },
    },


    language: {
      default: 'fr',
      translations: {
        fr: {
          consentModal: {
            title: 'Ce site utilise des cookies 🍪',
            description:
              'Nous utilisons des cookies essentiels pour le bon fonctionnement du site, ainsi que des cookies d’analyse pour améliorer votre expérience. Ceux-ci ne seront installés qu’avec votre consentement.',
            acceptAllBtn: 'Tout accepter',
            acceptNecessaryBtn: 'Refuser tout',
            showPreferencesBtn: 'Gérer les préférences',
            footer: `
              <a href="/politique-de-confidentialite">Politique de Confidentialité</a> • 
              <a href="/conditions-d-utilisation">Conditions d’utilisation</a>
            `,
          },
          preferencesModal: {
            title: 'Préférences de cookies',
            acceptAllBtn: 'Tout accepter',
            acceptNecessaryBtn: 'Refuser tout',
            savePreferencesBtn: 'Sauvegarder mes choix',
            closeIconLabel: 'Fermer',
            sections: [
              {
                title: 'Utilisation des cookies',
                description:
                  'Nous utilisons des cookies pour vous offrir la meilleure expérience possible. Modifiez vos préférences selon vos besoins. Pour plus d\'informations, consultez notre <a href="/politique-de-confidentialite" class="cc__link">politique de confidentialité</a>.',
              },
              {
                title: 'Cookies strictement nécessaires',
                description:
                  'Ces cookies sont indispensables au bon fonctionnement du site. Ils ne peuvent pas être désactivés.',
                linkedCategory: 'necessary',
              },
              {
                title: 'Cookies de performance et d’analyse',
                description:
                  'Ces cookies collectent des informations anonymes sur la manière dont les visiteurs utilisent le site, afin de nous aider à l’améliorer.',
                linkedCategory: 'analytics',
                cookieTable: {
                  headers: {
                    name: 'Cookie',
                    domain: 'Domaine',
                    desc: 'Description',
                  },
                  body: [
                    {
                      name: '_ga',
                      domain: `${runTimeConfig.public.clientBaseUrl}`,
                      desc: 'Utilisé par Google Analytics pour distinguer les utilisateurs.',
                    },
                    {
                      name: '_gid',
                      domain: `${runTimeConfig.public.clientBaseUrl}`,
                      desc: 'Utilisé par Google Analytics pour distinguer les sessions.',
                    },
                  ],
                },
              },
              {
                title: 'Cookies publicitaires et de ciblage',
                description:
                  'Ces cookies sont utilisés pour afficher des publicités pertinentes en fonction de vos intérêts.',
                linkedCategory: 'ads',
              },
              {
                title: 'Cookies de fonctionnalité',
                description:
                  'Ces cookies permettent d’activer des fonctionnalités supplémentaires sur le site, comme le chat, les préférences utilisateur ou la localisation.',
                linkedCategory: 'functionality',
              },
              {
                title: 'Cookies de personnalisation',
                description:
                  'Ces cookies permettent d’adapter le contenu du site à vos préférences (ex: langue, thème, interface).',
                linkedCategory: 'personalization',
              },
              {
                title: 'Plus d\'informations',
                description:
                  'Pour toute question concernant notre politique sur les cookies, vous pouvez <a class="cc__link" href="/contactez-nous">nous contacter</a>.',
              },
            ],
          },
        },
      },
    },
  }

  await CookieConsent.run(config)
  window.CC = CookieConsent

  return {
    provide: {
      CC: CookieConsent,
    },
  }
})